'use client'
import { slidesData4 } from '@/data/heroslides'
import { Autoplay, EffectFade, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import CustomImageComponent from '@imageUtils'
import styles from '@/components/homes/home-9/Hero.module.css'

// 加入 Swiper 樣式
import 'swiper/css'
import 'swiper/css/pagination'

const getHref = (item) => {
  if (item.IsInternalURL) {
    return item?.LinkURL
      ? `${item?.LinkURL?.trim()}${item.LinkURLPagePara.trim()}`
      : '#'
  } else {
    return item?.ExternalURL?.trim() || '#'
  }
}

export default function Hero({ banner }) {
  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 5000 }}
      slidesPerView={1}
      loop
      className="mySwiper hero-swiper w-100"
      pagination={true}
      // pagination={{
      //   el: '.slideshow-pagination', // 指定容器
      //   clickable: true, // 讓使用者可以點
      // }}
    >
      {banner.map((elm, i) => (
        <SwiperSlide key={i} className="swiper-slide">
          <div className="overflow-hidden position-relative w-100">
            <div style={{ width: '100%' }}>
              <Link href={getHref(elm)}>
                <Image
                  src={elm.ComputerPicturePath}
                  alt=""
                  width={1920}
                  height={640}
                  style={{
                    width: '100%',
                    height: 'auto', // ✅ 高度跟著圖片走
                    display: 'block',
                  }}
                />
              </Link>
            </div>
            {/* <div className="slideshow-text container position-absolute start-50 top-50 translate-middle">
              <h2 className="text-uppercase h1 fw-normal mb-0">{elm.title}</h2>
              <p>{elm.Description}</p>
              <Link
                href={getHref(elm)}
                className="btn-link btn-link_sm default-underline text-uppercase fw-medium"
              >
                Buy Now
              </Link>
            </div> */}
          </div>
        </SwiperSlide>
      ))}

      {/* <div className="slideshow-pagination position-left-center"></div> */}
    </Swiper>
  )
}
